<template>
  <router-view/>
</template>

<style>
@import "assets/css/reset.css";
/*共通*/
.btn{
  color: #20a0ff;
  padding: 0.3rem;
  border: solid #20a0ff 1px;
  border-radius: 0.3rem;
  margin-left: 5px;
}
.error {
  margin-top: 0.2rem;
  color: darkred;
  font-size: 0.7rem;
}
a {
  text-decoration: none;
}
.flex-box {
  display: flex;
}
/*メイン共通*/
#main-contents {
  padding: 1rem;
  min-width: 400px;
  flex: 1;
  width: auto;
  border: solid 2px #1f2d3d;
}
.content-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.content-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/*メインリスト*/
.main-list .content-search{
  border: solid #20a0ff 1px;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
}
.main-list .count{
  font-weight: bold;
}
.main-list .pager {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: center;
}

.main-list .pager span:hover {
  background-color: #42b983;
}

.main-list .pager span {
  border: solid #20a0ff 1px;
  color: white;
  background-color: #20a0ff;
  border-radius: 0.2rem;
  display: inline;
  padding: 3px;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
}
.main-list .content-search input,
.main-list .pager input {
  display: inline;
  margin: 0 0.2rem ;
  border: solid #20a0ff 1px;
  border-radius: 0.2rem;
  height: 2rem;
  width: 5rem;
  color: #20a0ff;
  text-align: center;
}
.main-list .content-search select,
.content-form select{
  display: inline;
  margin: 0 0.2rem ;
  border: solid #20a0ff 1px;
  border-radius: 0.2rem;
  height: 2rem;
  width: 5rem;
  /*color: #20a0ff;*/
  text-align: center;
}

.main-list .limit {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.main-list .limit ul {
  line-height: 2rem;
  text-align: right;
}

.main-list .limit li {
  border: solid #20a0ff 1px;
  color: white;
  background-color: #20a0ff;
  border-radius: 0.2rem;
  display: inline;
  padding: 3px;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
}

.main-list table {
  width: 100%;
}
.main-list table thead th {
  /*border: solid #20a0ff;*/
  background-color: #42b983;
  color: white;
  padding: 2px 4px;

}
.main-list table td {
  padding: 2px 4px;
  vertical-align: middle;
}
.main-list table tr:nth-child(even){
  background-color: #e8fcf0;
}
.main-list table tr:nth-child(odd){
  background-color: #c0f8d2;
}
.main-list table tr:hover {
  background-color: #d1ecff;
}
/*メイン詳細*/
.content-title h1 {
  font-size: 1.5rem;
  font-weight: bold;
}
.content-form {
  padding: 1rem;
  font-family: Arial, sans-serif;
  width: 80%;
}
.content-form .input-wrapper{
  /*margin-top: 0.5rem;*/
  margin-bottom: 1rem;
}
.content-form .required {
  color: red;
  font-weight: bold;
  padding-left: 0.3rem;
}
.content-form input,
.content-form textarea {
  display: block;
  border: solid #20a0ff 1px;
  color: black;
  background-color: white;
  border-radius: 0.2rem;
  margin-top: 0.2rem;
  padding-left: 0.5rem;
  line-height: 1.5rem;
}
.content-form input:focus,
.content-form textarea:focus {
  border: solid #20a0ff 2px;
}
.content-form textarea
.radio-box{
  display: flex;
  margin-top: 1rem;
}
.content-form select {
  border: solid #20a0ff 2px;
}
.content-form .radio-box {
  display: flex;
}
.content-form .radio-box input {
  margin-left: 1rem;
}
.content-form .radio-box label {
  margin-left: 0.3rem;
}
.content-form .buttons {
  margin-top: 2rem;
  display: flex;
}
.content-form .buttons .btn-delete{
  color: white;
  border: solid darkred 1px;
  background-color: darkred ;
}
.content-wrapper{
  display: flex;
}
.status-detail {
  width: 300px;

}
.status-detail table {
  border:  #20a0ff solid 1px;
  /*background-color: #20a0ff;*/
}
.status-detail th {
  background-color: #20a0ff;
  border: none;
  padding: 0.2rem;
  color: white;
  font-weight: normal;
  font-size: 0.7rem;
}
.status-detail td {
  background-color: #D1ECFFFF;
  color: black;
  border: none;
  font-weight: normal;
  font-size: 0.7rem;
}
</style>
<script>
export default {
  components: {}
}
</script>